import { Component } from '@angular/core';

@Component({
  selector: 'app-anniversary-of-dog-microchipping',
  templateUrl: './anniversary-of-dog-microchipping.component.html',
  styleUrl: './anniversary-of-dog-microchipping.component.scss'
})
export class AnniversaryOfDogMicrochippingComponent {

  constructor() {}

}
